// import camelCase from "lodash/camelCase";

// const requireModule = require.context(".", false, /\.js$/);
// const modules = {};

// requireModule.keys().forEach(fileName => {
//     if (fileName === "./index.js") return;

//     const moduleName = camelCase(fileName.replace(/(\.\/|\.js)/g, "")); //

//     modules[moduleName] = requireModule(fileName).default;
// });

// export default modules;

import Vue from 'vue'
import Vuex from 'vuex'
import cart from './modules/cart'
import campanhapontos from './modules/campanhapontos'
import modalCookiesPreferences from './modules/modalCookiesPreferences'
import modalNewsletterPreferences from './modules/modalNewsletterPreferences'
// import products from './modules/products'
// import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    cart,
    campanhapontos,
    modalCookiesPreferences,
    modalNewsletterPreferences
    // products
  },
  // strict: debug,
  // plugins: debug ? [createLogger()] : []
})